import { render } from "./HomeView.vue?vue&type=template&id=0033f27a&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=0033f27a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0033f27a"]])

export default __exports__